<div [formGroup]="form">
	<ng-container formArrayName="records">
		@for (control of recordsForm.controls; track control.value.fid) {
			<div [formGroupName]="$index" class="u-row u-row--sm">
				<tvcore-input [showErrors]="showErrors()" class="u-col-md-8" label="Detail" name="description" type="text">
					<tvcore-form-control-error name="required">Dit is verplicht.</tvcore-form-control-error>
				</tvcore-input>
				<tvcore-input [roundPrice]="true" [showErrors]="showErrors()" [type]="decimals() ? 'price-decimal' : 'price'" class="u-col-md-3" label="Bedrag" name="amount">
					<tvcore-form-control-error name="required">Dit is verplicht.</tvcore-form-control-error>
				</tvcore-input>
				<div class="u-col-md-1">
					@if (recordsForm.controls.length > 1) {
						<button (click)="removeLine($index)" class="c-btn-round" type="button">
							<span class="icon-trash"></span>
						</button>
					}
				</div>
			</div>
		}
	</ng-container>

	@if (!disableAdd()) {
		<button (click)="addLine()" class="u-m-top--sm c-btn c-btn--sm c-btn--secundary" type="button">+ lijn toevoegen</button>
	}
</div>
